import axios, { AxiosRequestConfig } from 'axios';
import { default as config } from '../../constants/constants';
import { DictationType, TagType } from '../../types/Flag';

interface FlagSearchCriteriaType {
  fromDate: string | null;
  toDate: string | null;
  tagsName: string[];
  podcastIds: number[];
  documentIds: number[];
  flashflag: boolean;
}

export const startFetchingFlags = () => {
  return {
    type: 'START_FETCHING_FLAGS',
    payload: true
  };
};

export const fetchSearchFlags = (
  token: string,
  values: FlagSearchCriteriaType,
  shared = true
) => {
  const options: AxiosRequestConfig = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notes/searchNotes?includeShared=${shared}`,
    data: values
  };

  return {
    type: 'FETCH_SEARCH_FLAGS',
    payload: axios(options)
  };
};

export const resetFlags = () => {
  return {
    type: 'RESET_FLAGS',
    payload: []
  };
};

export function fetchTagsByUser(token: string) {
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/tags/getTagsByUser`
  };
  return {
    type: 'FETCH_TAGS_BY_USER',
    payload: axios(options)
  };
}

export const manageTag = async (token: string, data: TagType) => {
  const options: AxiosRequestConfig = {
    method: 'PUT',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/tags`,
    data
  };

  try {
    await axios(options);
    return {
      type: 'MANAGE_TAG',
      payload: { data }
    };
  } catch (error) {
    throw error;
  }
};

export const updateDictation = (token: string, data: DictationType) => {
  const options: AxiosRequestConfig = {
    method: 'PUT',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notes`,
    data
  };

  return {
    type: 'UPDATE_DICTATION',
    payload: axios(options)
  };
};
